export function ThematicCard({ title, description, icon, learnMore = true }) {
  return (
    <div className="flex flex-col items-center gap-10">
      {icon}
      <h3 className="text-2xl font-bold text-center">{title}</h3>
    </div>
  );
}
